import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HeroSection = ({ isLoaded }) => {
  const scrollToAbout = () => {
    const element = document.querySelector("#om-oss");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_premium-el-design/artifacts/j4rkaufh_20220913_154121.jpg"
          alt="Optimal EL firmabil vid modern villa"
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/40 via-[#050505]/60 to-[#050505]/95" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 md:px-12 pt-24 pb-16 md:pt-32 md:pb-24">
        <div className="max-w-4xl">
          {/* Label */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isLoaded ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4 md:mb-6"
          >
            Premium Elinstallation • Stockholm
          </motion.p>

          {/* Main Heading */}
          <motion.h1
            data-testid="hero-title"
            initial={{ opacity: 0, y: 40 }}
            animate={isLoaded ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-manrope font-light text-white leading-[1.1] tracking-tight mb-6 md:mb-8"
          >
            Elinstallationer
            <br />
            <span className="text-zinc-400">med designkänsla.</span>
          </motion.h1>

          {/* Subheading */}
          <motion.p
            data-testid="hero-subtitle"
            initial={{ opacity: 0, y: 40 }}
            animate={isLoaded ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="text-sm md:text-lg text-zinc-400 max-w-xl mb-8 md:mb-10 leading-relaxed"
          >
            Vi skapar genomtänkta, säkra och estetiska elinstallationer 
            för hem och fastigheter i Stockholm.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={isLoaded ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col sm:flex-row gap-3 md:gap-4"
          >
            <a
              href="#kontakt"
              data-testid="hero-cta-primary"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#kontakt")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="bg-[#D4AF37] text-black px-6 md:px-8 py-3 md:py-4 font-medium tracking-wide hover:bg-[#C5A028] transition-all duration-300 text-center"
            >
              Få Offert
            </a>
            <a
              href="tel:0722930914"
              data-testid="hero-cta-secondary"
              className="bg-transparent border border-white/20 text-white px-6 md:px-8 py-3 md:py-4 font-medium tracking-wide hover:bg-white/10 transition-all duration-300 text-center"
            >
              Kontakta Oss
            </a>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.button
          initial={{ opacity: 0 }}
          animate={isLoaded ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 1.2 }}
          onClick={scrollToAbout}
          data-testid="scroll-indicator"
          className="hidden md:block absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 text-zinc-500 hover:text-white transition-colors cursor-pointer"
          aria-label="Scrolla ner"
        >
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          >
            <ArrowDown size={24} />
          </motion.div>
        </motion.button>
      </div>
    </section>
  );
};

export default HeroSection;
